

/**
 * @name AssociationsListController
 * @param {service} Association Service for association
 * @param {constant} NOTIFICATIONS The nofiticaitons constant
 * @param {service} Notification The nofiticaiton service
 * @param {service} Session The Session service
 * @param {service} $uibModal The $uibModal service from ui bootstrap
 * @param {service} AlertMessages The AlertMessages service
 * @param {constant} RESPONSE_MESSAGES The RESPONSE_MESSAGES constant
 * @param {library} _ The Lodash library
 */
function AssociationsListController(
  Association,
  NOTIFICATIONS,
  Notification,
  Session,
  $uibModal,
  AlertMessages,
  RESPONSE_MESSAGES,
  _
) {
  let vm = this;

  vm.accept = accept;
  vm.decline = decline;
  vm.edit = edit;
  vm.expire = expire;

/**
  * @description
  * Accept an Invite
  * @param {object} association The association to accept
  */
  function accept(association) {
    Association.accept(association).then(function(updatedAssociation) {
      vm.onChange();

      // Send email notifications
      if (association.type === 'operator') {
        // Send the  notification if an operator accepted this invite
        let notification = {
          recipients: [], // API will send email to all operators at the shop
          notificationId: NOTIFICATIONS.operatorAccept,
          messageObjects: {
            shopId: association.shop.id,
            // The operator accepting the invite
            operatorId: Session.collector.id
          },
          messageVariables: {
            subject: Session.collector.first_name + ' ' +
            Session.collector.last_name +
            ' accepted an invite to be an operator at ' +
            association.shop.name
          }
        };
        Notification.send(notification);
      } else if (association.type === 'artist') {
        // Send the notification if an operator accepted this invite
        let notification = {
          recipients: [], // API will send email to all operators at the shop
          notificationId: NOTIFICATIONS.artistAccept,
          messageObjects: {
            shopId: association.shop.id,
            artistId: Session.collector.id // The artist accepting the invite
          },
          messageVariables: {
            subject: Session.collector.first_name + ' ' +
            Session.collector.last_name +
            ' accepted an invite to be an artist at ' +
            association.shop.name
          }
        };
        Notification.send(notification);
      }
    });
  }

  /**
   * @name decline
   * @description Function to decline an association
   * @param {object} association The collector to cancel
   */
  function decline(association) {
    let modalInstance = $uibModal.open({
      template: require('./decline-association-modal.template.html'),
      animation: true,
      controller: 'DeclineAssociationController',
      bindToController: true,
      controllerAs: '$ctrl',
      resolve: {
        association: function() {
          return association;
        }
      }
    });
    modalInstance.result.then(function(udpatedAssociation) {
      _.remove(vm.associations, function(association) {
        return association.id === udpatedAssociation.id;
      });
    }, function() {
      AlertMessages.add({
        msg: RESPONSE_MESSAGES.closedWithoutSaving,
        type: 'warning'
      });
    });
  }

  /**
   * @name edit
   * @description Function to edit an association
   * @param {object} association The collector to cancel
   */
  function edit(association) {
    let modalInstance = $uibModal.open({
      template: require('./edit-association-modal.template.html'),
      animation: true,
      controller: 'EditAssociationController',
      bindToController: true,
      controllerAs: '$ctrl',
      resolve: {
        association: function() {
          return association;
        }
      }
    });
    modalInstance.result.then(function(udpatedAssociation) {
      vm.onChange();
      AlertMessages.add({
        msg: RESPONSE_MESSAGES.saved,
        type: 'success'
      });
    }, function() {
      AlertMessages.add({
        msg: RESPONSE_MESSAGES.closedWithoutSaving,
        type: 'warning'
      });
    });
  }

  /**
   * @name expire
   * @description Function to open the expire association modal
   * @param {object} association The association to expire
   */
  function expire(association) {
    let modalInstance = $uibModal.open({
      template: require('./expire-association-modal.template.html'),
      animation: true,
      controller: 'ExpireAssociationController',
      bindToController: true,
      controllerAs: '$ctrl',
      resolve: {
        association: function() {
          return association;
        }
      }
    });
    modalInstance.result.then(function(udpatedAssociation) {
      _.remove(vm.associations, function(association) {
        return association.id === udpatedAssociation.id;
      });
      AlertMessages.add({
        msg: RESPONSE_MESSAGES.saved,
        type: 'success'
      });
    }, function() {
      AlertMessages.add({
        msg: RESPONSE_MESSAGES.closedWithoutSaving,
        type: 'warning'
      });
    });
  }
}

angular
  .module('inkfinder')
  .controller('AssociationsListController', AssociationsListController);



// WEBPACK FOOTER //
// ./components/collector/associations/list/associations-list.controller.js